import { render, staticRenderFns } from "./DeliverablesInProjectList.vue?vue&type=template&id=8eb05788&"
import script from "./DeliverablesInProjectList.vue?vue&type=script&lang=js&"
export * from "./DeliverablesInProjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports